<template>
  <v-container>
    <!-- ปฏิทิน -->
    <v-sheet min-height="600">
      <v-calendar
          class="custom-calendar"
          v-model="selectedDate"
          :events="events"
          :event-name="getEventName"
          :event-color="getEventColor"
          :event-text-color="getEventTextColor"
          :event-height="40"
          :day-class="getDayClass"
          event-overlap-mode="stack"
          @click:event="showEventDetails"
      />
    </v-sheet>

    <!-- Modal สำหรับแสดงรายละเอียดกิจกรรม -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>{{ selectedEvent.title || 'ไม่มีข้อมูลกิจกรรม' }}</v-card-title>
        <v-card-text>
          <p><strong>รายละเอียด:</strong> {{ selectedEvent.details || '-' }}</p>
          <p><strong>วันที่เริ่ม:</strong> {{ formatDate(selectedEvent.start) }}</p>
          <p><strong>วันที่สิ้นสุด:</strong> {{ formatDate(selectedEvent.end) }}</p>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialog = false">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { format } from "date-fns"; // ใช้ date-fns สำหรับจัดการวันที่

export default {
  data() {
    return {
      selectedDate: new Date().toISOString().substring(0, 10), // วันที่ที่เลือกในปฏิทิน
      dialog: false, // เปิด/ปิด Modal
      selectedEvent: {}, // ข้อมูลกิจกรรมที่เลือก
      events: [
        {
          name: "กิจกรรม 1",
          start: "2025-01-01",
          end: "2025-01-07",
          startTime: "09:00",
          endTime: "12:00",
          color: "red",
          textColor: "white",
          details: "รายละเอียดของกิจกรรม 1",
        },
        {
          name: "กิจกรรม 2",
          start: "2025-01-01",
          end: "2025-01-02",
          startTime: "12:00",
          endTime: "19:00",
          color: "blue",
          textColor: "white",
          details: "รายละเอียดของกิจกรรม 2",
        },
        {
          title: "กิจกรรม 3",
          name: "กิจกรรม 3",
          start: "2025-01-09",
          end: "2025-01-09",
          details: "รายละเอียดของกิจกรรม 3",
        },
      ],
    };
  },
  methods: {
    // ฟังก์ชันสำหรับเลือกสีของกิจกรรม
    getEventColor(event) {
      return event.color || "#FDECE7";
    },
    getEventTextColor(event) {
      return event.textColor || "#F65F3C";
    },
    getEventName(event) {
      return `${event.startTime || ""} ${event.title}`;
    },
    // แสดง Modal เมื่อคลิกกิจกรรม
    showEventDetails({ event }) {
      this.selectedEvent = event;
      this.dialog = true;
    },
    // เพิ่มคลาสสำหรับวันที่พิเศษ (วันที่ปัจจุบัน)
    getDayClass(day) {
      const today = new Date().toISOString().split("T")[0];
      return day.date === today ? "today" : "";
    },
    // ฟังก์ชันจัดการวันที่ให้อยู่ในรูปแบบที่อ่านง่าย
    formatDate(date) {
      if (!date) return "-";
      return format(new Date(date), "yyyy-MM-dd");
    },
  },
};
</script>

<style>
.theme--light.v-calendar-weekly .v-calendar-weekly__day {
  border-right: #e0e0e0 1px solid;
  border-bottom: #e0e0e0 1px solid;
  color: #000000;
  min-height: 200px;
}
.v-calendar-weekly__day-label {
  text-decoration: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  -webkit-box-shadow: none;
  box-shadow: none;
  text-align: left;
  margin: 4px 0px 0px 8px;
}
.v-calendar-weekly__day-label .v-btn{
  font-size: 18px;
  text-transform: none;
}
</style>